export default "__VITE_ASSET__WBNWMPXH__"